import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY_FORM = { name: '', email: '', interest: '', message: '' };

/**
 * Manages contact form state, field updates, and submission.
 * Returns { form, submitting, update, handleSubmit }.
 */
export function useContactForm({ text, onSuccess, lang = 'EN' }) {
  const [form, setForm]           = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false);

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));
  const set    = (field) => (v) => setForm((f) => ({ ...f, [field]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/contact`, { ...form, lang });
      toast.success(text.success, { duration: 5000 });
      setForm(EMPTY_FORM);
      onSuccess();
    } catch (err) {
      const msg = err?.response?.data?.detail || 'Something went wrong. Please try again.';
      toast.error(msg, { duration: 6000 });
    } finally {
      setSubmitting(false);
    }
  };

  return { form, submitting, update, set, handleSubmit };
}
